// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* .select-team-field {
    position: relative;
    margin: var(--space-and-half) 0;
} */
.select-team-field::placeholder {
    color: var(--disabled-color);
}

.select-team-field-input {
    border: 1px solid var(--new-gray-color);
    padding: 0 var(--space-half);
    width: 100%;
    height: var(--space-x3);
    max-height: var(--space-x3);
    border-radius: calc( var(--space-half) + 1px );
}
.select-team-field-input.error {
    border: var(--input-field-border-error);
}

/* ul.MuiList-root li{
    text-transform: inherit !important;

} */

.MuiInput-underline.select-team-field-input:before, .MuiInput-underline.select-team-field-input:hover:not(.Mui-disabled):before{
    border-bottom: unset;
}

.select-team-field-label {
    position: absolute;
    top: calc( calc(var(--space-and-half) + var(--space-half) ) * -1 );
    left: 0;
    font-weight: var(--font-medium);
    font-family: var(--secondary-font);
    line-height: calc( var(--space) + var(--space-quarter));
    font-size: calc( var(--space) + 1px );
    padding-top: var(--space-half);
    z-index: 1;
    display: flex;
    align-items: center;
    letter-spacing: 0.0025em;
    color: var(--basic-gray-color);
    text-transform: capitalize;
}

.select-team-field-icon{
    width: var(--space-and-half);
    margin-right: var(--space-half-quarter);
}

.select-team-field-input .MuiInputBase-input {
    display: flex;
    align-items: center;
}

.select-team-field-clean__icon-list {
    font-size: var(--space-and-half);
    margin-right: var(--space-half-quarter);
}

.select-team-field-input .MuiSelect-select:focus {
    background-color: unset;
}

.select-team-field-input__list__icon{
    margin-right: 11px;
}

.select-team-field-input__list__icon__img{
    width: 38px;
    height: 38px;
    border-radius: 50%;
}

.MuiListItemText-root.select-team-field-input__listitem {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
}

/* .select-team-field-input__listitem .MuiTypography-body1 {
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: calc( var(--space) - 2px );
    line-height: calc(var(--space) + 4);
    display: flex;
    align-items: center;
    letter-spacing: 0.0025em;
    color: var(--primary-dark-color) !important;
}

.select-team-field-input__listitem .MuiTypography-colorTextSecondary {    
    color: var(--basic-gray-color);
    font-size: var(--space-half-quarter);
    line-height: 16px;
} */

.select-team-field-input__list__icon .icon-ball{
    color: var(--white-color);
    font-size: 30px;
    padding: 4px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/select-team-field/SelectTeamFieldComponent.styles.css"],"names":[],"mappings":";AACA;;;GAGG;AACH;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;IACvC,4BAA4B;IAC5B,WAAW;IACX,uBAAuB;IACvB,2BAA2B;IAC3B,8CAA8C;AAClD;AACA;IACI,uCAAuC;AAC3C;;AAEA;;;GAGG;;AAEH;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,kEAAkE;IAClE,OAAO;IACP,+BAA+B;IAC/B,kCAAkC;IAClC,uDAAuD;IACvD,qCAAqC;IACrC,8BAA8B;IAC9B,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,uCAAuC;AAC3C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;;;;;;;;;;;;;;;;GAgBG;;AAEH;IACI,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":["\n/* .select-team-field {\n    position: relative;\n    margin: var(--space-and-half) 0;\n} */\n.select-team-field::placeholder {\n    color: var(--disabled-color);\n}\n\n.select-team-field-input {\n    border: 1px solid var(--new-gray-color);\n    padding: 0 var(--space-half);\n    width: 100%;\n    height: var(--space-x3);\n    max-height: var(--space-x3);\n    border-radius: calc( var(--space-half) + 1px );\n}\n.select-team-field-input.error {\n    border: var(--input-field-border-error);\n}\n\n/* ul.MuiList-root li{\n    text-transform: inherit !important;\n\n} */\n\n.MuiInput-underline.select-team-field-input:before, .MuiInput-underline.select-team-field-input:hover:not(.Mui-disabled):before{\n    border-bottom: unset;\n}\n\n.select-team-field-label {\n    position: absolute;\n    top: calc( calc(var(--space-and-half) + var(--space-half) ) * -1 );\n    left: 0;\n    font-weight: var(--font-medium);\n    font-family: var(--secondary-font);\n    line-height: calc( var(--space) + var(--space-quarter));\n    font-size: calc( var(--space) + 1px );\n    padding-top: var(--space-half);\n    z-index: 1;\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0025em;\n    color: var(--basic-gray-color);\n    text-transform: capitalize;\n}\n\n.select-team-field-icon{\n    width: var(--space-and-half);\n    margin-right: var(--space-half-quarter);\n}\n\n.select-team-field-input .MuiInputBase-input {\n    display: flex;\n    align-items: center;\n}\n\n.select-team-field-clean__icon-list {\n    font-size: var(--space-and-half);\n    margin-right: var(--space-half-quarter);\n}\n\n.select-team-field-input .MuiSelect-select:focus {\n    background-color: unset;\n}\n\n.select-team-field-input__list__icon{\n    margin-right: 11px;\n}\n\n.select-team-field-input__list__icon__img{\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n}\n\n.MuiListItemText-root.select-team-field-input__listitem {\n    margin-top: 0px !important;\n    margin-bottom: 0px !important;\n}\n\n/* .select-team-field-input__listitem .MuiTypography-body1 {\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: calc( var(--space) - 2px );\n    line-height: calc(var(--space) + 4);\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0025em;\n    color: var(--primary-dark-color) !important;\n}\n\n.select-team-field-input__listitem .MuiTypography-colorTextSecondary {    \n    color: var(--basic-gray-color);\n    font-size: var(--space-half-quarter);\n    line-height: 16px;\n} */\n\n.select-team-field-input__list__icon .icon-ball{\n    color: var(--white-color);\n    font-size: 30px;\n    padding: 4px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
